export enum ITeamAnalyticsActivityEnum {
  StartTime = 'TeamAnalyticsActivity.starttime',
  LocalStartTime = 'TeamAnalyticsActivity.localstarttime',
  LocalStartDate = 'TeamAnalyticsActivity.localStartDate',
  LocalEndTime = 'TeamAnalyticsActivity.localendtime',
  LocalEndDate = 'TeamAnalyticsActivity.localenddate',
  Count = 'TeamAnalyticsActivity.count',
  AppId = 'TeamAnalyticsActivity.appid',
  SubscriptionId = 'TeamAnalyticsActivity.subscriptionid',
  AverageDailyDuration = 'TeamAnalyticsActivity.averageDailyDuration',
  AverageDailyCallDuration = 'TeamAnalyticsActivity.averageDailyCallDuration',
  AverageDailyCallInteractions = 'TeamAnalyticsActivity.averageDailyCallInteractions',
  AverageInteractionDuration = 'TeamAnalyticsActivity.averageInteractionDuration',
  UserId = 'TeamAnalyticsActivity.userid',
  StartTimeDay = 'TeamAnalyticsActivity.starttime.day',
  LocalStartTimeDay = 'TeamAnalyticsActivity.localstarttime.day',
  LocalStartTimeWeek = 'TeamAnalyticsActivity.localstarttime.week',
  DayCount = 'TeamAnalyticsActivity.dayCount',
  TeamId = 'TeamAnalyticsActivity.teamId',
  PerUserAvgDuration = 'TeamAnalyticsActivity.perUserAvgDuration',
  PerUserAvgCount = 'TeamAnalyticsActivity.perUserAvgCount',
  PerUserAvgCallDuration = 'TeamAnalyticsActivity.perUserAvgCallDuration',
  PerUserAvgCallCount = 'TeamAnalyticsActivity.perUserAvgCallCount',
  TotalDuration = 'TeamAnalyticsActivity.totalDuration',
  MaxDuration = 'TeamAnalyticsActivity.maxDuration',
  AverageDailyInteractions = 'TeamAnalyticsActivity.averageDailyInteractions',
  AverageWeeklyDuration = 'TeamAnalyticsActivity.averageWeeklyDuration',
  AverageWeeklyInteractions = 'TeamAnalyticsActivity.averageWeeklyInteractions',
  AverageWeeklyCallDuration = 'TeamAnalyticsActivity.averageWeeklyCallDuration',
  AverageWeeklyCallInteractions = 'TeamAnalyticsActivity.averageWeeklyCallInteractions',
  WeekCount = 'TeamAnalyticsActivity.weekCount',
  UserCount = 'TeamAnalyticsActivity.userCount',
  PerUserAvgDailyDuration = 'TeamAnalyticsActivity.perUserAvgDailyDuration',
  PerUserAvgDailyInteractions = 'TeamAnalyticsActivity.perUserAvgDailyInteractions',
  PerUserAvgWeeklyDuration = 'TeamAnalyticsActivity.perUserAvgWeeklyDuration',
  PerUserAvgWeeklyInteractions = 'TeamAnalyticsActivity.perUserAvgWeeklyInteractions',
  HeatmapSegment = 'TeamAnalyticsActivity.heatmapsegment',
  WeekdayIndex = 'TeamAnalyticsActivity.weekdayindex',
  TotalCallDuration = 'TeamAnalyticsActivity.totalCallDuration',
  CallCount = 'TeamAnalyticsActivity.callCount',
  AverageCallInteractionDuration = 'TeamAnalyticsActivity.averageCallInteractionDuration',
  CallDuration = 'TeamAnalyticsActivity.callDuration',
}

export enum ITeamAnalyticsActivityV2Enum {
  StartTime = 'TeamAnalyticsActivityV2.starttime',
  LocalStartTime = 'TeamAnalyticsActivityV2.localstarttime',
  LocalStartDate = 'TeamAnalyticsActivityV2.localStartDate',
  LocalEndTime = 'TeamAnalyticsActivityV2.localendtime',
  LocalEndDate = 'TeamAnalyticsActivityV2.localenddate',
  Count = 'TeamAnalyticsActivityV2.count',
  AppId = 'TeamAnalyticsActivityV2.appid',
  SubscriptionId = 'TeamAnalyticsActivityV2.subscriptionid',
  AverageDailyDuration = 'TeamAnalyticsActivityV2.averageDailyDuration',
  AverageDailyCallDuration = 'TeamAnalyticsActivityV2.averageDailyCallDuration',
  AverageDailyCallInteractions = 'TeamAnalyticsActivityV2.averageDailyCallInteractions',
  AverageInteractionDuration = 'TeamAnalyticsActivityV2.averageInteractionDuration',
  UserId = 'TeamAnalyticsActivityV2.userid',
  StartTimeDay = 'TeamAnalyticsActivityV2.starttime.day',
  LocalStartTimeDay = 'TeamAnalyticsActivityV2.localstarttime.day',
  LocalStartTimeWeek = 'TeamAnalyticsActivityV2.localstarttime.week',
  DayCount = 'TeamAnalyticsActivityV2.dayCount',
  TeamId = 'TeamAnalyticsActivityV2.teamId',
  PerUserAvgDuration = 'TeamAnalyticsActivityV2.perUserAvgDuration',
  PerUserAvgCount = 'TeamAnalyticsActivityV2.perUserAvgCount',
  PerUserAvgCallDuration = 'TeamAnalyticsActivityV2.perUserAvgCallDuration',
  PerUserAvgCallCount = 'TeamAnalyticsActivityV2.perUserAvgCallCount',
  TotalDuration = 'TeamAnalyticsActivityV2.totalDuration',
  MaxDuration = 'TeamAnalyticsActivityV2.maxDuration',
  AverageDailyInteractions = 'TeamAnalyticsActivityV2.averageDailyInteractions',
  AverageWeeklyDuration = 'TeamAnalyticsActivityV2.averageWeeklyDuration',
  AverageWeeklyInteractions = 'TeamAnalyticsActivityV2.averageWeeklyInteractions',
  AverageWeeklyCallDuration = 'TeamAnalyticsActivityV2.averageWeeklyCallDuration',
  AverageWeeklyCallInteractions = 'TeamAnalyticsActivityV2.averageWeeklyCallInteractions',
  WeekCount = 'TeamAnalyticsActivityV2.weekCount',
  UserCount = 'TeamAnalyticsActivityV2.userCount',
  PerUserAvgDailyDuration = 'TeamAnalyticsActivityV2.perUserAvgDailyDuration',
  PerUserAvgDailyInteractions = 'TeamAnalyticsActivityV2.perUserAvgDailyInteractions',
  PerUserAvgWeeklyDuration = 'TeamAnalyticsActivityV2.perUserAvgWeeklyDuration',
  PerUserAvgWeeklyInteractions = 'TeamAnalyticsActivityV2.perUserAvgWeeklyInteractions',
  HeatmapSegment = 'TeamAnalyticsActivityV2.heatmapsegment',
  WeekdayIndex = 'TeamAnalyticsActivityV2.weekdayindex',
  TotalCallDuration = 'TeamAnalyticsActivityV2.totalCallDuration',
  CallCount = 'TeamAnalyticsActivityV2.callCount',
  AverageCallInteractionDuration = 'TeamAnalyticsActivityV2.averageCallInteractionDuration',
  CallDuration = 'TeamAnalyticsActivityV2.callDuration',
}
